import FileService from '@/services/file.service';

export const fileModule = {
    namespaced: true,
    state: {
        fileObj: "",
        fileBytes: "",
    },
    actions: {
        downloadFile({commit}, url) {
            return FileService.downloadFile(url).then(
                data => {
                    commit('updateFileBytes', data)
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        getFile({commit}, fileId) {
            return FileService.getFile(fileId).then(
                data => {
                    commit('updateFileObj', data)
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        getProductImage({commit}, imageId) {
            return FileService.getProductImage(imageId).then(
                data => {
                    commit('updateFileObj', data)
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateFileObj(state, data) {
            state.fileObj = data
        },
        updateFileBytes(state, data) {
            state.fileBytes = data
        },
    }
};